// @ts-ignore
import { GandalfArray } from 'gandalf';
// @ts-ignore
import { GandalfConstantDecorator } from 'gandalf';
// @ts-ignore
import { GandalfLabel } from 'gandalf';
// @ts-ignore
import { GandalfModel } from 'gandalf';
// @ts-ignore
import { GandalfModelBase } from 'gandalf';
// @ts-ignore
import { GandalfProperty } from 'gandalf';
// @ts-ignore
import { GandalfSubRequestLabel } from 'gandalf';
// @ts-ignore
import { GandalfValidator } from 'gandalf';
// @ts-ignore
import * as constants from '../constants';


// @ts-ignore
import { CreatePaymentRequest } from './create-payment-request';

/** See com.rev360.pms.api.controller.accounting.practicepay.PracticePayCreatePaymentGroupRequest */
/* istanbul ignore next */
@GandalfModel
export class PracticePayCreatePaymentGroupRequest extends GandalfModelBase {

	@GandalfLabel('Apply In Full')
	@GandalfProperty({ designType: Boolean })
	applyFull!: boolean | null;

	@GandalfConstantDecorator(constants.PracticePayCardBrand)
	@GandalfLabel('Card Brand')
	@GandalfValidator({ notNull: { message: 'Card Brand is required' } })
	@GandalfProperty({ designType: constants.PracticePayCardBrand, isRequired: true })
	cardBrand!: constants.PracticePayCardBrand;

	@GandalfLabel('Comment')
	@GandalfValidator({ sizeString: { message: 'Comment cannot be longer than 255 characters', minLength: 0, maxLength: 255 } })
	@GandalfProperty({ designType: String })
	comment!: string | null;

	@GandalfLabel('Payer Entity')
	@GandalfProperty({ designType: Number })
	payerEntityId!: number | null;

	@GandalfConstantDecorator(constants.PayerType)
	@GandalfLabel('Payer Type')
	@GandalfValidator({ notNull: { message: 'Payer Type is required' } })
	@GandalfProperty({ designType: constants.PayerType, isRequired: true })
	payerType!: constants.PayerType;

	@GandalfLabel('Amount')
	@GandalfValidator({ notNull: { message: 'Amount is required' } })
	@GandalfProperty({ propertyType: 'Money', designType: Number, isRequired: true })
	paymentAmount!: number;

	@GandalfLabel('Payment Date')
	@GandalfValidator({ notNull: { message: 'Payment Date is required' } })
	@GandalfProperty({ propertyType: 'LocalDate', designType: Date, isRequired: true })
	paymentDate!: Date;

	@GandalfLabel('Payment Group')
	@GandalfProperty({ designType: Number })
	paymentGroupId!: number | null;

	@GandalfLabel('Payment Location')
	@GandalfProperty({ designType: Number })
	paymentLocationId!: number | null;

	@GandalfConstantDecorator(constants.PaymentMethodType)
	@GandalfLabel('Payment Method')
	@GandalfValidator({ notNull: { message: 'Payment Method is required' } })
	@GandalfProperty({ designType: constants.PaymentMethodType, isRequired: true })
	paymentMethodType!: constants.PaymentMethodType;

	@GandalfLabel('Payment Transaction')
	@GandalfProperty({ designType: Number })
	paymentTransactionId!: number | null;

	@GandalfArray(CreatePaymentRequest)
	payments!: CreatePaymentRequest[];

	@GandalfLabel('Reference Number')
	@GandalfValidator({ sizeString: { message: 'Reference Number cannot be longer than 50 characters', minLength: 0, maxLength: 50 } })
	@GandalfProperty({ designType: String })
	referenceNumber!: string | null;

	@GandalfLabel('Practice Location')
	@GandalfProperty({ designType: Number })
	sourcePracticeLocationId!: number | null;

	@GandalfConstantDecorator(constants.PaymentGroupSourceType)
	@GandalfLabel('Source Type')
	@GandalfValidator({ notNull: { message: 'Source Type is required' } })
	@GandalfProperty({ designType: constants.PaymentGroupSourceType, isRequired: true })
	sourceType!: constants.PaymentGroupSourceType;

}
